import { PublicArtistLink as GQLItem } from '../generated/checkout.graphql';

export type CheckoutArtistLink = {
  url: string;
};

export const fromGql = (gqlItem: GQLItem): CheckoutArtistLink => ({
  url: gqlItem.url,
});

export const fromGqlCollection = (gqlItems: GQLItem[]): CheckoutArtistLink[] =>
  gqlItems.map(fromGql);
